import gql from 'graphql-tag';

export default gql`
  fragment MessageFragment on Message {
    _id
    text
    messageUsers {
      isRead
      user
    }
    data {
      lessonSerialNumber
      exerciseSerialNumber
      subject
    }
    repliedMessage {
      data {
        lessonSerialNumber
        exerciseSerialNumber
      }
      _id
      text
      creator {
        login
        _id
        firstName
        lastName
        isSubscribedToPosts
        email
        phone
        avatar {
          path
        }
        role
      }
    }
    creator {
      login
      _id
      firstName
      lastName
      isSubscribedToPosts
      email
      phone
      avatar {
        path
      }
      role
    }
    createdAt
  }
`;
